export default __webpack_public_path__ + "5f32ee6a3d89db163fba19c5a1361d87.svg";